import { useSyncExternalStore } from "react";

import { getMessagesVersion, subscribeToMessages } from "../i18n";

/**
 * Re-render when a message part arrives (ADR-WES1). The app adds this to its
 * `t` memo so copy that rendered before its part loaded repaints.
 */
export function useMessagesVersion(): number {
  return useSyncExternalStore(subscribeToMessages, getMessagesVersion, getMessagesVersion);
}
